// extracted by mini-css-extract-plugin
module.exports = {"doc-badge":"doc-badge_doc-badge__p6vMy","href":"doc-badge_href__IXpbb"};